import { Box } from "@mantine/core";
import React from "react";
import {
  BscScan,
  EtherScan,
  Eth,
  OptimisticEtherscanScan,
  CronosScan,
  CronosScanLight,
  ArbiScan,
  PolygonScan,
  Snowtrace,
  Avalanche,
  FTMScan,
  Bsc,
  FTM,
  EthBase64,
  BscBase64,
  OptimisticEtherscanScanBase64,
  CronosScanLightBase64,
  CronosScanBase64,
  ArbiScanBase64,
  PolygonScanBase64,
  AvalancheBase64,
  FTMBase64,
} from "../../Components/EpIcon";

export const getBase64SrcOfChainIcon = ({
  chain,
  dark,
}: {
  chain?: {
    name?: string;
    etherscanName?: string;
    etherscanUrlPrefix?: string;
  };
  dark?: boolean;
}) => {
  const icon =
    {
      EEtherscan: EthBase64,
      BscScan: BscBase64,
      Optimism: OptimisticEtherscanScanBase64,
      Cronos: dark ? CronosScanLightBase64 : CronosScanBase64,
      Arbiscan: ArbiScanBase64,
      Polygonscan: PolygonScanBase64,
      SNOWTRACE: AvalancheBase64,
      FTMScan: FTMBase64,
    }[chain?.etherscanName || ""] || EthBase64;

  return icon;
};

export const getChainIcon = ({
  chain,
  txhash,
  dark,
  size,
  showChainName,
}: {
  chain?: {
    name?: string;
    etherscanName?: string;
    etherscanUrlPrefix?: string;
  };
  txhash?: string;
  dark?: boolean;
  size?: number;
  showChainName?: boolean;
}) => {
  const icon = {
    Etherscan: <Eth size={size} />,
    BscScan: <Bsc size={size} />,
    Optimism: <OptimisticEtherscanScan size={size} />,
    Cronos: dark ? <CronosScanLight size={size} /> : <CronosScan size={size} />,
    Arbiscan: <ArbiScan size={size} />,
    Polygonscan: <PolygonScan size={size} />,
    SNOWTRACE: <Avalanche size={size} />,
    FTMScan: <FTM size={size} />,
  }[chain?.etherscanName || ""] || <Eth size={size} />;

  const scanIcon = {
    Etherscan: <EtherScan size={size} />,
    BscScan: <BscScan size={size} />,
    Optimism: <OptimisticEtherscanScan size={size} />,
    Cronos: dark ? <CronosScanLight size={size} /> : <CronosScan size={size} />,
    Arbiscan: <ArbiScan size={size} />,
    Polygonscan: <PolygonScan size={size} />,
    SNOWTRACE: <Snowtrace size={size} />,
    FTMScan: <FTMScan size={size} />,
  }[chain?.etherscanName || ""] || <Eth size={size} />;

  return {
    label: showChainName ? chain?.name : chain?.etherscanName,
    icon: <Box>{showChainName ? icon : scanIcon}</Box>,
    href: `${chain?.etherscanUrlPrefix}/tx/${txhash}`,
  } as {
    label: string;
    icon: React.ReactNode;
    href: string;
  };
};

export default getChainIcon;
